import {createContext, useContext} from 'react';

import type {AppRatesContextType} from './types';

// The context object and its hook live in this JSX-free module so that
// AppRatesProvider.tsx only exports a component and keeps its Fast Refresh
// boundary. Consumers keep importing `useAppRates` from '@/context/AppRatesContext'.
export const AppRatesContext = createContext<AppRatesContextType | undefined>(
  undefined,
);

export const useAppRates = () => {
  const context = useContext(AppRatesContext);
  if (context === undefined) {
    throw new Error(
      'useAppRatesContext must be used within an AppRatesProvider',
    );
  }
  return context;
};
